module.exports = __webpack_public_path__ + "static/media/play-white.40bc2173.svg";